export default __webpack_public_path__ + "logo.8176e43a.svg";